import PropTypes from "prop-types";
import { propTypesColors } from "../generic";
export var propTypesColor = propTypesColors;
export var propTypesLabel = PropTypes.string;
export var propTypesIcon = PropTypes.node;
export var propTypesRipple = PropTypes.bool;
export var propTypesClassName = PropTypes.string;
export var propTypesContainerProps = PropTypes.instanceOf(Object);
export var propTypesLabelProps = PropTypes.instanceOf(Object);
export var propTypesCircleProps = PropTypes.instanceOf(Object);
